'use client';

import { Suspense, useContext, useEffect, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

import { CartContext } from '../CartProvider/CartProvider';
import { MenuTabNavigation } from './MenuTabNavigation/MenuTabNavigation';
import { ShopTabNavigationModal } from './ShopTabNavigation/ShopTabNavigationModal';
import { ViewMyOrderButton } from './ViewMyOrderButton/ViewMyOrderButton';

export default function MenuPage() {
	const { apiCart, firstCartFetchFinished, isFromCampaign, setIsFromCampaign, setCampaignName } =
		useContext(CartContext);
	const [isModalOpen, setIsModalOpen] = useState<boolean>();
	const searchParams = useSearchParams();
	const campaignName = searchParams.get('utm_campaign');

	useEffect(() => {
		if (campaignName) {
			setIsFromCampaign(true);
			setCampaignName(campaignName);
		}
	}, [campaignName, setIsFromCampaign, setCampaignName]);

	const router = useRouter();

	const closeModal = () => {
		setIsModalOpen(false);
	};

	const openModal = () => {
		setIsModalOpen(true);
	};

	useEffect(() => {
		const cartTypeFromParams = searchParams.get('type');
		const cartType = cartTypeFromParams === 'delivery' ? 'dispatch' : cartTypeFromParams;
		const shopNumFromParams = searchParams.get('sn');

		if (shopNumFromParams) {
			setIsModalOpen(true);
		} else if (apiCart && apiCart.deliveryMode === cartType) {
			setIsModalOpen(false);
		} else if (firstCartFetchFinished) {
			setIsModalOpen(true);
		} else if (isFromCampaign) {
			setIsModalOpen(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [firstCartFetchFinished, isFromCampaign]);

	useEffect(() => {
		const cartTypeFromParams = searchParams.get('type');
		const redirectFrom = searchParams.get('redirectFrom');
		if (
			(cartTypeFromParams === 'pickup' || cartTypeFromParams === 'delivery') &&
			redirectFrom === 'review'
		) {
			setIsModalOpen(true);
			router.replace(`/shop/menu?type=${cartTypeFromParams}`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="overscroll-none">
			<div className="px-2 md:px-4">
				<MenuTabNavigation />
			</div>
			{
				<Suspense>
					<ShopTabNavigationModal
						redirectOnClose={!apiCart}
						isModalOpen={isModalOpen}
						closeModal={closeModal}
						openModal={openModal}
						buttonStyle="text"
						redirectedFrom={searchParams.get('redirectFrom') === 'review' ? 'review' : ''}
					/>
				</Suspense>
			}
			<ViewMyOrderButton />
		</div>
	);
}
